export default "__VITE_ASSET__C9L0ejaS__"